import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export default async function postEmployerAllowance(
  businessId,
  employerAllowanceAttributes,
  activeEmployerInfo
) {
  const apiPath = `employer-allowances/${businessId}`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: employerAllowanceAttributes,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
}
